import React, { useEffect, useState } from "react";
// import LogoSvg from "../../../assets/svgs/Logo.svg";
import { Img } from "../../core/design-system/Img";
import { Text } from "../../core/design-system/Text";
import useTailwindBreakpoints from "../../../hooks/useTailwindBreakPoints";
import { Logo } from "../../core/design-system/Logo/Logo";
interface HeaderProps {
  // Define your prop types here
}

const Header: React.FC<HeaderProps> = () => {
  const [username, setUsername] = useState("");
  const { xs, sm, lg, xl } = useTailwindBreakpoints();
  console.log("xs", xs, "sm", sm, "lg", lg, "xl", xl);

  useEffect(() => {
    setUserName();
  }, []);

  const setUserName = () => {
    const user = localStorage.getItem("user");
    if (user) {
      const userData = JSON.parse(user);
      setUsername(userData?.username);
    }
  };

  const location = window.location.pathname;

  return (
    <div className="relative z-0 pt-[1.5em] pb-[0.8em]  px-6">
      <div className="flex flex-1 flex-row justify-between items-center">
        {location === "/transaction" ? (
          <Text className="text-xl font-medium leading-6 text-center SemiBold m-0">
            Transaction
          </Text>
        ) : (
          <Logo
            className="xs:w-[6rem] sm:w-[6rem] lg:w-[8rem] 5xl:w-[10rem]"
          />
        )}
        <div className=" flex flex-row items-center gap-4">
          <div className="flex flex-row justify-between ">
            <Img
              src={"user_avatar.svg"}
              alt="logo"
              className="xs:w-[2.5em] 5xl:size-[3em] rounded-full overflow-hidden h-[2.5em]"
            />

            <div className="flex flex-col justify-center items-start ml-2 ">
              <p className="xs:text-xs 5xl:text-lg text-darkGray font-medium text-start">
                Welcome Back
              </p>
              <p className="xs:text-xs sm:text-xs lg:text-sm 5xl:text-lg  font-norml text-start 5xl:font-normal">
                {username}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
